<template>
  <div>
    <div class="user-avator-dropdown">
      <span>欢迎您，{{userName}}</span> |
      <Dropdown @on-click="onAccountClick">
        <span>
          账户设置
          <i class="iconfont icon-arrow-down"></i>
        </span>
        <DropdownMenu slot="list">
          <DropdownItem name="editPwd">修改密码</DropdownItem>
        </DropdownMenu>
      </Dropdown> |
      <span @click="onSetPointClick">积分设置</span> |
      <span @click="onLogoutClick" style="color:#ff7600">退出</span>
    </div>
    <Modal title="修改密码" v-model="modalVisible" class="modal_edit" width="420px">
      <Form ref="formValidate" :model="formValidate" :rules="rules" :label-width="80">
        <FormItem prop="oldPassword" label="原密码 :">
          <Input v-model="formValidate.oldPassword" type="password"/>
        </FormItem>
        <FormItem prop="newPassword" label="新密码 :">
          <Input v-model="formValidate.newPassword" type="password"/>
        </FormItem>
        <FormItem prop="newPassword1" label="确认密码 :">
          <Input v-model="formValidate.newPassword1" type="password"/>
        </FormItem>
      </Form>
      <div slot="footer" class="modal_footer">
        <Button type="primary" @click="onModalOK">确定</Button>
      </div>
    </Modal>
    <Modal title="积分规则设置" v-model="pointModalVisible" class="modal_edit" width="420px">
      <Form ref="pointFormValidate" :model="pointFormValidate" :rules="pointRules" :label-width="50">
        <FormItem prop="pointDeductProporty" label="消费">
          <Input v-model="pointFormValidate.pointDeductProporty" style="width:120px"/> 积分抵扣1元
        </FormItem>
        <FormItem prop="pointObtainProporty" label="消费">
          <Input v-model="pointFormValidate.pointObtainProporty" style="width:120px"/> 元获得1积分
          <RadioGroup v-model="pointFormValidate.enable" style="margin-left:10px">
            <Radio label="YES">启用</Radio>
            <Radio label="NO">停用</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div slot="footer" class="modal_footer">
        <Button type="primary" @click="onPointModalOK">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import './user.less'
import { mapActions } from 'vuex'
import { setPassword, addPointrule, updatePointrule, getPointrule } from '@/api/user'
import cookies from '@/libs/util.cookies.js'
import Formatter from '@/assets/js/formatter.js'
import cryptoJs from 'crypto-js'
export default {
  name: 'User',
  props: {
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    const validPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.formValidate.newPassword1 !== '') {
          this.$refs.formValidate.validateField('newPassword1')
        }
        callback()
      }
    }
    const validPassword1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formValidate.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      modalVisible: false,
      formValidate: {
        oldPassword: '',
        newPassword: '',
        newPassword1: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validPassword, trigger: 'blur' }
        ],
        newPassword1: [
          { required: true, validator: validPassword1, trigger: 'blur' }
        ]
      },
      pointModalVisible: false,
      pointFormValidate: {
        ruleId: '',
        pointDeductProporty: '',
        pointObtainProporty: '',
        enable: 'YES'
      },
      pointRules: {
        pointDeductProporty: [
          { required: true, validator: Formatter.validInteger('请输入积分（不能小于1）'), trigger: 'blur' }
        ],
        pointObtainProporty: [
          { required: true, validator: Formatter.validInteger('请输入金额（不能小于1）'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions('account/', [
      'logout'
    ]),
    onLogoutClick () {
      let _this = this
      if (!cookies.get('token')) {
        _this.$router.push({name: 'Login'})
        return
      }
      this.logout({
        vm: _this
      })
    },
    onAccountClick (name) {
      switch (name) {
        case 'editPwd': this.modalVisible = true
          break
      }
      this.$refs.formValidate.resetFields()
    },
    onModalOK () {
      let _this = this
      _this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let params = {
            employeeId: cookies.get('employeeId'),
            oldPassword: cryptoJs.MD5(_this.formValidate.oldPassword).toString(),
            newPassword: cryptoJs.MD5(_this.formValidate.newPassword).toString()
          }
          setPassword(params).then(res => {
            _this.$common.successTip('密码修改成功，请重新登录！')
            cookies.remove('token')
            _this.$router.push({name: 'Login'})
          }).catch(e => {
            console.log(e)
            _this.$common.errorTip(e.message)
          })
          _this.modalVisible = false
        }
      })
    },
    getPointrule () {
      getPointrule().then(res => {
        if (res.data.bean) {
          this.pointFormValidate = {
            ruleId: res.data.bean.ruleId,
            pointDeductProporty: res.data.bean.pointDeductRoporty,
            pointObtainProporty: res.data.bean.pointObtainProporty,
            enable: res.data.bean.enable
          }
        }
      }).catch(e => {
        console.log(e)
        this.$common.errorTip(e.message)
      })
    },
    onSetPointClick () {
      this.pointModalVisible = true
      this.$refs.pointFormValidate.resetFields()
      this.getPointrule()
    },
    onPointModalOK () {
      let _this = this
      _this.$refs['pointFormValidate'].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.pointFormValidate))
          if (params.ruleId) {
            updatePointrule(params).then(res => {
              _this.$common.successTip('积分修改成功！')
            }).catch(e => {
              console.log(e)
              _this.$common.errorTip(e.message)
            })
          } else {
            addPointrule(params).then(res => {
              _this.$common.successTip('积分设置成功！')
            }).catch(e => {
              console.log(e)
              _this.$common.errorTip(e.message)
            })
          }

          _this.pointModalVisible = false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue